import React from 'react';
import { Box, Button, Tooltip } from '@chakra-ui/react';
import { PiPlusBold } from 'react-icons/pi';

function FloatingPlusButton({ onClick, tooltip, title, ariaLabel, ...rest }) {
    const buttonElement = (
        <Button
            w="56px"
            h="56px"
            rounded="full"
            colorScheme="purple"
            shadow="2xl"
            _hover={{ transform: "scale(1.08)", shadow: "dark-lg" }}
            _active={{ transform: "scale(0.95)" }}
            transition="all 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
            p={0}
            onClick={onClick}
            aria-label={ariaLabel || tooltip || title || "Ajouter"}
            {...rest}
        >
            <PiPlusBold size={24} />
        </Button>
    );

    return (
        <Box
            position="fixed"
            bottom={6}
            right={6}
            zIndex={999}
        >
            {tooltip || title ? (
                <Tooltip label={tooltip || title} placement="left" hasArrow>
                    {buttonElement}
                </Tooltip>
            ) : (
                buttonElement
            )}
        </Box>
    );
}

export default FloatingPlusButton;
